<!--
 * @Description: 项目模块
 * @Version: 1.0
 * @Autor: steFan
 * @Date: 2020-03-10 09:15:03
 * @LastEditors: steFan
 * @LastEditTime: 2020-04-01 14:44:25
 :style="{backgroundImage:`url(${require(''+a)})`}"
 -->
<template>
    <div id="app">
        <div class="loadingBgc" v-show="splash">
            <transition name="slide-fade" mode="out-in">
                <Splash ref="splash"></Splash>
            </transition>
        </div>
        <transition name="slide-fade" mode="out-in">
            <router-view class></router-view>
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import Splash from "./components/splash/splash";
import {_getDeviceInfo} from './utils/finger'
export default {
    name: "App",
    components: { Splash },
    data() {
        return {
            splash: true,
            splashId: "",
            isShow: false
        };
    },
    created() {
       
        if (!sessionStorage.getItem("splash")) {
            sessionStorage.setItem("splash", true);
            this.splash = true;
            this.splashId = 1;
        } else {
            this.splashId = 2;
            this.splash = false;
        }
        if (this.$common.isLogin()) {
            this.$store.commit("setToken", this.$common.getToken());
            this.$nkhttp.getUserInfo();
        }
        if (window.mask && !this.$common.isLogin()) {
            this.splash = false;
            this.$router.push({path: "/index"});
            return;
        }
        let host = this.$common.getHost();
        let imgUrl = this.$common.getImgUrlImg();
        if (imgUrl) {
            imgUrl = process.env.NODE_ENV !== 'production' ? imgUrl : window.location.origin + '/file';
            this.$config.imgHost = imgUrl;
        }
       
        this.forDataJson(host);
        this.maintainUrl();
        //  间隔维护
        let interval = window.interval || 18000;
        setInterval(() => {
            this.maintainUrl();
        }, interval);
    },
    mounted() {
        this.loading();
        _getDeviceInfo().then( res => {
            this.$config.phoneModel = res.browserType
        })
    },
    methods: {
        maintainUrl() {
            let that = this;
             let clientCode = window.clientCode;
            let clientItem = window.childCode;
            let theme = 1;
            let lang = this.$common.getLocale() ||window.locale;
            // let mainUrl = window.maintainUrl;
            let mainUrl = '/clientMaintain/getClientMaintain'
            that.$http.mainPost(mainUrl, false).then(res => {
                if (res.code == 0) {
                    if (res.data.status === 1) {
                        let u = window.location.protocol+'//'+window.location.host;
                            let o = res.data.maintainUrl;
                            let str = `${o}?c=${clientCode}&i=${clientItem}&t=${theme}&l=${lang}&u=${u}`;
                            window.location.href = str;
                    }
                } else {
                    // 正常能访问
                }
            });
        },
        loading() {
            if (this.splashId != 1) return // 如果加载过了就不加载了
            let that = this
            let i = 0
            const step = 3 // 请求间隔
            const times = 3 // 请求几次后提示超时
            let setIntval = setInterval(() => {
                i++
                check()
                if (i >= step * times) {
                    clearInterval(setIntval)
                    // 提示用户超时
                    this.$message.error('网络超时，请稍后刷新页面重试')
                }
            }, 1000)

            // 检查拿到isShow没
            function check () {
                if (that.isShow) return over()
                if (i % step == 0) that.forDataJson(that.host)
            }

            // 拿到isShow后的结束逻辑
            function over () {
                sessionStorage.setItem('splash', true)
                clearInterval(setIntval)
                that.$refs.splash.over()
                setTimeout(() => { // 500ms的结束动画
                    that.splash = false
                }, 500)
            }
        },
        // 跳转
        routerActive(item, index) {
            this.routerIndex = index;
        },
        // 获取
        forDataJson(list) {
            let self = this;
            if (list && list.length) {
                let host = "";
                if (self.$config.host == "http://192.168.1.241:9999") {
                    host = self.$config.host;
                } else {
                    host = list;
                }
                let configs = { isLoading: false };
                axios
                    .get(host + "/longm/api/v1/domain/pageList", {
                        configs: configs
                    })
                    .then(function(res) {
                        self.isShow = true;
                        if (res.status == 200) {
                            if (res.data.code == 0) {
                                self.$config.baseUrl = host;
                                self.$common.setConfigHost(host);
                                let dataUrl = res.data.data;
                                self.$common.setConfigUrl(dataUrl);
                                self.clientCode();
                                dataUrl.map(item => {
                                    if (item.type == 1) {
                                        //web
                                        self.$config.codeUrl = item.domain;
                                    } else if (item.type == 2) {
                                        //图片
                                        let imgHost = process.env.NODE_ENV !== 'production' ? item.domain : window.location.origin + '/file'
                                        self.$config.imgHost = imgHost;
                                        self.$common.setImgUrlImg(item.domain);
                                    }else if (item.type == 3) { 
                                        //下载
                                        self.$config.dowUrl = item.domain + '/';
                                        self.$common.setDowUrl(item.domain + '/');
                                    }else if (item.type == 4) { 
                                        ///彩金
                                        self.$config.jackpotUrl = item.domain;
                                        self.$common.setJackpotUrl(item.domain);
                                    }else if (item.type == 5) { 
                                        //客服
                                        self.$config.customerServiceUrl = item.domain;
                                        self.$common.setCustomerServiceUrl(item.domain);
                                    }else if (item.type == 6) {
                                        // ios下载地址
                                        self.$config.iosDownloadUrl = item.domain;
                                        self.$common.setIosDownloadUrl(item.domain);
                                    }else if (item.type == 7) {
                                        // 安卓下载地址
                                        self.$config.androidDownloadUrl = item.domain;
                                        self.$common.setAndroidDownloadUrl(item.domain);
                                    }else if (item.type == 8) {
                                        // pc下载地址
                                        self.$config.pcDownloadUrl = item.domain;
                                        self.$common.setPcDownloadUrl(item.domain);
                                    }else if (item.type == 9) {
                                        // pc主站域名
                                        self.$config.pcMainUrl = item.domain;
                                    }else if (item.type == 10) {
                                        //pc易记域名
                                        self.$config.pcYijiUrl = item.domain;
                                    }
                                });
                                sessionStorage.setItem("restraint", false);
                                return;
                            } else if (res.data.code == 110009) {
                                // sessionStorage.setItem("restraint", true);
                                self.splash = false
                                self.$router.push({
                                    name: 'iplimit',
                                    query: {
                                        ip: res.data.msg,
                                        custommerUrl: res.data.data.customer
                                    }
                                })
                            } else {
                                self.$message.error(res.data.msg);
                            }
                        } else if (res.status == 500 || res.status == 503) {
                            self.$message.error(
                                "服务器维护中,请稍后再试！！！"
                            );
                        } else if (res.status == 401) {
                            self.$common.clearToken();
                            self.$message.error(
                                "您的登录账户已经过期，请您重新登录"
                            );
                        } else {
                            // else if (res.status !== 500 || res.status !== 503 || res.status !== 401){
                            //  self.forDataJson(list);
                            return;
                        }
                    })
                    .catch(function(error) {});
            } else {
            }
        },
        // get clientCode
        clientCode: async function() {
            let self = this;
            let params = "/" + window.clientCode;
            const res = await self.$http.get(
                self.$api.clientCode,
                params,
                false
            );
            if (res.code == 0) {
                self.$common.setCustomerService(res.data.customerUrl);
                self.$common.setClientCodeRes(res.data);
            } else {
                // this.$message.error(res.msg + "");
            }
        }
    }
};
</script>

<style>
img[lazy=loading] {
    object-fit: contain!important;
}
img[lazy=error] {
    object-fit: contain!important;
}
</style>
<style>
/* @import "./assets/css/base.css";
@import "./assets/css/main.css";
@import "./assets/css/commonqq.css"; */
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    background-size: cover;
    font-size: 14px;
}
.bg {
    background: #050010 !important;
}
/* ------- 极验验证码 start  ------------- */
.geetest_holder.geetest_wind {
    height: 0.44rem !important;
    min-width: 0 !important;
}
.geetest_holder.geetest_wind .geetest_radar_btn,
.geetest_holder.geetest_wind .geetest_success_btn {
    min-width: 0 !important;
}

.geetest_holder.geetest_wind .geetest_radar_btn .geetest_radar {
    width: 0.3rem !important;
    height: 0.3rem !important;
    margin: 0.06rem !important;
}

.geetest_holder.geetest_wind .geetest_radar_tip,
.geetest_holder.geetest_wind .geetest_success_radar_tip {
    height: 0.44rem !important;
    line-height: 0.44rem !important;
    color: #313131 !important;
    text-align: center !important;
    font-size: 0.14rem !important;
    padding: 0 0.46rem 0 0.46rem !important;
}
.geetest_holder.geetest_wind .geetest_success_btn .geetest_success_box {
    top: 0.09rem !important;
    left: 0.07rem !important;
}
.geetest_holder.geetest_wind .geetest_success_btn .geetest_success_box,
.geetest_holder.geetest_wind
    .geetest_success_btn
    .geetest_success_box
    .geetest_success_show {
    width: 0.24rem !important;
    height: 0.24rem !important;
}
.geetest_holder.geetest_wind
    .geetest_success_btn
    .geetest_success_box
    .geetest_success_correct {
    right: -0.04rem !important;
    top: -0.04rem !important;
    width: 0.28rem !important;
    height: 0.28rem !important;
}
.geetest_holder.geetest_wind
    .geetest_success_btn
    .geetest_success_box
    .geetest_success_correct
    .geetest_success_icon {
    top: 0.06rem !important;
    right: 0.06rem !important;
    width: 0.18rem !important;
    height: 0.18rem !important;
}
/* ---------  极验验证码  end ---------- */
</style>
